// extracted by mini-css-extract-plugin
export default {"convertingPopup":"purchase-failed_convertingPopup__xlIs5","animation":"purchase-failed_animation__MizGQ"};